import React, { useEffect , useCallback , useState } from 'react';
import { useParams } from "react-router-dom";

import { useGlobalContext } from '../../context/GlobalContext';

import { useForm } from "react-hook-form";
import { API_URL } from '../../../actions';
import { clearMarkup } from '../../../utils/utils';

import EditKeysFigures from '../../partials/EditKeysFigures';
import EditPage from '../../partials/EditPage';
import EditKnowledge from './EditKnowledge';
import Talent from '../career/Talent';
import Partner from './Partner';
import TextEditor from '../../partials/TextEditor';
import SelectMedia from '../medias/SelectMedia';
import PromptRouter from '../../partials/PromptRouter';
import RemoveModale from '../../partials/RemoveModale/RemoveModale';

import { getMediasAction } from '../../../actions/mediasActions';
import { getCompanyAction } from '../../../actions/companiesActions';
import { getPageAction , updatePageAction } from '../../../actions/themeActions';
import { getTalentsAction } from '../../../actions/talentsActions';
import { getPartnersAction } from '../../../actions/partnersActions';

import MetaSeo from '../../partials/MetaSeo';

import '../../../styles/pages-sites.scss';

export default function Innovations({ setDisplayNavBar, setDisplaySelectLang , setDisplaySiteNav , requireRight , setActivePage , theme , lang }) {

  const param = useParams();

  const page = 'innovation';

  const { handleSubmit, register, errors } = useForm();

  const [ context, dispatch ] = useGlobalContext();

  const [ innovations , setInnovations ] = useState();
  const [ talents , setTalents ] = useState();
  const [ addTalent , setAddTalent ] = useState(false);
  const [ partners , setPartners ] = useState();
  const [ addPartner , setAddPartner ] = useState(false);
  const [ knowledges , setKnowledges ] = useState([]);

  const [ isMounted , setIsMounted ] = useState(false);
  const [ isSaved , setIsSaved ] = useState(true);
  const [ removeAction , setRemoveAction ] = useState();

  const [ displaySelectMedia , setDisplaySelectMedia ] = useState(false);
  const [ selectedMediaList , setSelectedMediaList ] = useState([]);
  const [ mediaIsMulti , setMediaIsMulti ] = useState(false);
  const [ mediaType , setMediaType ] = useState();
  const [ mediaKey , setMediaKey ] = useState('picture');
  const [ publishIsLoading , setPublishIsLoading ] = useState(false);
  const [ pages , setPages ] = useState([]);
  const [ index , setIndex ] = useState();

  const hasTalentRight = typeof requireRight === 'function' ? requireRight("talent") : false;

  const getCompany = useCallback(() => {
    getCompanyAction(dispatch , param.companyId );
    getMediasAction(dispatch, param.companyId);
    if (hasTalentRight) getTalentsAction(dispatch , lang);
    getPartnersAction(dispatch , lang);
  },[dispatch , param.companyId , lang , hasTalentRight ]);

  useEffect(() => {
    setDisplayNavBar(true);
    setDisplaySelectLang(true);
    setDisplaySiteNav(true)
    setActivePage("innovation");
    getCompany();
    return () => {
      setDisplaySelectLang(false);
      setInnovations();
      setIsMounted(false)
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (hasTalentRight) getTalentsAction(dispatch , lang);
    // eslint-disable-next-line
  }, [context.auth.userAuth]);

  useEffect(() => {
    getPageAction(dispatch , param.companyId , page , lang );
    if (hasTalentRight) getTalentsAction(dispatch , lang);
    getPartnersAction(dispatch , lang);
    setInnovations();
    setIsMounted(false);
    dispatch({
      type:'RESET_PAGE',
    });
    // eslint-disable-next-line
  },[lang]);

  useEffect(() => {
    if (context.talents.talentsList) {
      setTalents(context.talents.talentsList.filter(t => t.company === param.companyId && t.category === 'innovation'));
    }
  }, [context.talents.talentsList , context.talents.message , param.companyId])

  useEffect(() => {
    if (context.partners.partnersList) {
      setPartners(context.partners.partnersList.filter(p => p.company === param.companyId));
    }
  }, [context.partners.partnersList , context.partners.message , param.companyId])

  useEffect(() => {
    if (innovations && context.theme.page) {
      if (innovations && context?.theme?.page && JSON.stringify(innovations) === JSON.stringify(context.theme.page)) {
        setIsSaved(true);
      } else {
        setIsSaved(false);
      }
    }
    // eslint-disable-next-line
  },[innovations])

  useEffect(() => {
    if (context.theme.page) {
      setInnovations({...context.theme.page });
      if (context.theme.page.pages) {
        setPages(context.theme.page.pages)
      }
      if (context.theme.page.knowledges) {
        setKnowledges(context.theme.page.knowledges)
      }
      setIsMounted(true);
    } else {
      setInnovations();
      setIsMounted(false);
    };

    dispatch({
      type:'MESSAGE_PAGE',
      payload: null
    });
    // eslint-disable-next-line
  }, [context.theme.page]);

  useEffect(() => {
    if (context.talents.message === 'Talent successfully updated!' || context.talents.message === "talent saved") {
      setIsSaved(true);
      setAddTalent(false);
      dispatch({
        type:'MESSAGE_TALENTS',
        payload: null
      });
    };
    // eslint-disable-next-line
  },[context.talents.message]);

  useEffect(() => {
    if (context.partners?.message === 'Partner successfully updated!' || context.partners?.message === "partner saved") {
      setAddPartner(false);
      dispatch({
        type:'MESSAGE_PARTNERS',
        payload: null
      });
    };
    // eslint-disable-next-line
  },[context.partners?.message]);

  useEffect(() => {
    if (context.theme && context.theme.message === 'Theme successfully updated' ) {

      setPublishIsLoading(false);

      dispatch({
        type:'MESSAGE_PAGE',
        payload: null
      });

      dispatch({
        type: 'SET_TOAST',
        payload: {
          message: "La page a bien été enregistré",
          type: "success"
        }
      });

    };

    // eslint-disable-next-line
  },[context.theme.message]);

  useEffect(() => {
    if (!displaySelectMedia) {
      setIndex();
    }
  }, [displaySelectMedia])



  function submitMedia(value) {
    var pageList  = [...pages]
    switch (mediaKey) {

      case "picture":
        setInnovations({...innovations, picture: value[0] })
        break;

      case "cover":
        setInnovations({...innovations, cover: value[0] })
        break;

      case "pageCover":
          pageList[index].cover = value[0] ;
          setPages(pageList)
        break;


      case "pagePicture":
          pageList[index].picture = value[0] ;
          setPages(pageList)
        break;

      case "talentVideo":
          var talentList = [...talents]
          talentList[index] = {...talentList[index] , video: value[0] }
          setTalents(talentList)
        break;

      case "talentPicture":
          var talentListPicture = [...talents]
          talentListPicture[index] = {...talentListPicture[index] , picture: value[0] }
          setTalents(talentListPicture)
        break;

      case "partnerVideo":
          var partnerList = [...(partners || [])]
          partnerList[index] = {...partnerList[index] , video: value[0] }
          setPartners(partnerList)
        break;

      case "partnerPicture":
          var partnerListPicture = [...(partners || [])]
          partnerListPicture[index] = {...partnerListPicture[index] , picture: value[0] }
          setPartners(partnerListPicture)
        break;

      case "knowledgePicture":
          var knowledgeList = [...knowledges]
          knowledgeList[index] = {...knowledgeList[index] , picture: value[0] }
          setKnowledges(knowledgeList)
        break;

      default:
        break;
    }
  };

  function openSelectCover() {
    setDisplaySelectMedia(true);
    setMediaIsMulti(false);
    setMediaKey(param.companyId === "5e9ec41b25ab1e65768e2ff0" ? 'picture' : 'cover');
    setMediaType('image');
    if (innovations && innovations.picture) {
      var pictureArray = [];
      pictureArray.push(innovations.picture);
      setSelectedMediaList(pictureArray)
    }
  }

  function openSelectPicture(index , key ) {
    setIndex(index)
    setDisplaySelectMedia(true);
    setMediaIsMulti(false);
    setMediaKey(key);
    setMediaType(key === 'file' ? 'file' : 'image');
  }

  function openSelectTalentVideo(index) {
    setIndex(index)
    setDisplaySelectMedia(true);
    setMediaIsMulti(false);
    setMediaKey('talentVideo');
    setMediaType('video');
  }

  function openSelectKnowledgePicture(i) {
    setIndex(i);
    setDisplaySelectMedia(true);
    setMediaIsMulti(false);
    setMediaKey('knowledgePicture');
    setMediaType('image');
  }

  function openSelectPartnerVideo(index) {
    setIndex(index)
    setDisplaySelectMedia(true);
    setMediaIsMulti(false);
    setMediaKey('partnerVideo');
    setMediaType('video');
  }

  const submitInnovations = (values)  => {
    var innovationsData = {...values, ...innovations};
    if (pages) {
      innovationsData.pages = pages
    }
    if (knowledges) {
      innovationsData.knowledges = knowledges
    }
    var obj = {};
    for (const [key, value] of Object.entries(innovationsData)) {
        if (key !== 'articles' && key !== 'talents' && key !== 'partners') obj[`${page}.${key}`] = value;
    }

    setPublishIsLoading(true);

    if (param.companyId === "5e9ec41b25ab1e65768e2ff0") {
      updatePageAction(dispatch , context.companies.company.theme[lang] , 'group' , page , obj  );
    } else {
      updatePageAction(dispatch , context.companies.company.theme[lang] , 'subsidiary' , page , obj  );
    }

    dispatch({
      type:'ERROR_PAGE',
      payload: null
    });
    dispatch({
      type:'MESSAGE_PAGE',
      payload: null
    });
  };

  function renderCoverImg() {
    var imgFound;
    if(innovations && innovations.picture && context.medias.mediasList) {
      imgFound = context.medias.mediasList.find(item => item._id === innovations.picture )
      if (imgFound) {
        return <img src={API_URL + '/' + imgFound.path} alt="innovations" />
      } else if (innovations.picture && innovations.picture.path) {
        return <img src={API_URL + '/' + innovations.picture.path} alt="innovations" />
      }
    }
    if(innovations && innovations.cover && context.medias.mediasList) {
      imgFound = context.medias.mediasList.find(item => item._id === innovations.cover )
      if (imgFound) {
        return <img src={API_URL + '/' + imgFound.path} alt="innovations" />
      } else if (innovations.cover && innovations.cover.path) {
        return <img src={API_URL + '/' + innovations.cover.path} alt="innovations" />
      }
    }
  }

  function renderEdit() {
    return (
      <div className="list-item transition edit-row">
        <form onSubmit={handleSubmit(submitInnovations)} autoComplete="nope">

            <div className="form-row">
              <div className="col-1">

                <div className="title">
                  <h1 dangerouslySetInnerHTML={{ __html: innovations && innovations.title ? clearMarkup(innovations.title) : "" }} ></h1>
                </div>

                <label htmlFor="innovations-title">Titre de la page</label>
                <input
                  id="innovations-title"
                  name="title"
                  onChange={(e) => setInnovations({...innovations, title: e.target.value})}
                  defaultValue={innovations.title ? innovations.title  : undefined }
                  ref={register({
                    required: "Compléter le titre",
                  })}
                />
                <p className="error">{errors && errors.title && errors.title.message}</p>

                <div>
                  <input id="isWhite"
                    onChange={() => setInnovations({...innovations, titleIsWhite: !innovations.titleIsWhite })}
                    type="checkbox"
                    className="switch"
                    checked={!innovations.titleIsWhite}
                    />
                  <label htmlFor="isWhite">{innovations.titleIsWhite ? <span>Titre en blanc</span> : <span>Titre en noir</span> }</label>
                </div>

                <div className="section"></div>

                <label>Paragraphe d'introduction</label>
                <TextEditor
                  value={innovations.text || ""}
                  onChange={(value) => setInnovations({...innovations, text: value})}
                />

                <div className="section"></div>

                <div className="title">
                  <h2>Production de connaissances</h2>
                </div>

                <label htmlFor="innovations-knowledgeTitle">Titre de la section</label>
                <input
                  id="innovations-knowledgeTitle"
                  name="knowledgeTitle"
                  onChange={(e) => setInnovations({...innovations, knowledgeTitle: e.target.value})}
                  defaultValue={innovations.knowledgeTitle || ""}
                />

                <label>Description de la section</label>
                <TextEditor
                  value={innovations.knowledgeDescription || ""}
                  onChange={(value) => setInnovations({...innovations, knowledgeDescription: value})}
                />

                <div className="list-container">
                  {knowledges && knowledges.map((k, i) => (
                    <EditKnowledge
                      key={'knowledge' + i}
                      knowledgeValue={k}
                      knowledges={knowledges}
                      setKnowledges={setKnowledges}
                      index={i}
                      theme={theme}
                      openSelectKnowledgePicture={openSelectKnowledgePicture}
                      setRemoveAction={setRemoveAction}
                      context={context}
                    />
                  ))}
                </div>

                <div className="btn-container">
                  <button
                    className={`btn primary ${theme}-bg`}
                    style={{ marginBottom: 20 }}
                    onClick={() => setKnowledges([...knowledges, { text: '', picture: null }])}
                    type="button"
                  >
                    Ajouter un élément
                  </button>
                </div>

                <div className="section"></div>

                <div className="title">
                  <h2>Chiffres clés</h2>
                </div>

                <EditKeysFigures keyFigures={innovations.keyFigures} setRemoveAction={setRemoveAction} handleChange={ keyList => setInnovations({...innovations, keyFigures: keyList })} theme={theme}/>

                <div className="section"></div>

                <div className="title">
                  <h2>Pages innovations</h2>
                </div>

                {pages && pages.sort((a , b ) => a.pos - b.pos ).map((p , i) => <EditPage
                  key={'pages' + i }
                  pageValue={p}
                  pages={pages}
                  setPages={(array) => setPages(array) }
                  companyId={param.companyId}
                  context={context}
                  withThumbnail={true}
                  withHeaderFlag={true}
                  setRemoveAction={setRemoveAction}
                  openSelectPicture={openSelectPicture}
                  dispatch={dispatch}
                  index={i}
                  />)
                }

                <div className="btn-container" >
                  <button
                    className={`btn primary ${theme}-bg`}
                    style={{ marginBottom: 20}}
                    onClick={() => setPages([...pages ,{ title: null , pos: pages.length +1 , blocs: [], cover: null , titleIsWhite: false , isHeader: false } ]) }
                    type="button"
                    >
                    Ajouter une page
                  </button>
                </div>

                {hasTalentRight &&
                  <>
                    <div className="section"></div>

                    <div className="title">
                      <h2>Les talents</h2>
                    </div>

                    <div className="list-container">

                      {!addTalent && talents && talents.map((talent, i ) => (<Talent
                        key={talent?._id || 'talent' + i }
                        talentValue={talent}
                        companyId={param.companyId}
                        lang={lang}
                        context={context}
                        setRemoveAction={setRemoveAction}
                        openSelectTalentVideo={openSelectTalentVideo}
                        openSelectPicture={openSelectPicture}
                        dispatch={dispatch}
                        theme={theme}
                        category="innovation"
                        index={i} />
                      ))}

                    </div>

                    <div className="btn-container" >
                      <button
                        className={`btn primary ${theme}-bg`}
                        style={{ marginBottom: 20}}
                        onClick={() => setTalents([...(talents || []) , {}]) }
                        type="button"
                        >
                        Ajouter un talent
                      </button>
                    </div>

                    <div className="section"></div>

                    <div className="title">
                      <h2>Section collaborateurs</h2>
                    </div>

                    <label htmlFor="innovations-collaboratorTitle">Titre de la section</label>
                    <input
                      id="innovations-collaboratorTitle"
                      name="collaboratorTitle"
                      onChange={(e) => setInnovations({ ...innovations, collaboratorTitle: e.target.value })}
                      defaultValue={innovations.collaboratorTitle || ""}
                    />

                    <label>Description de la section</label>
                    <TextEditor
                      value={innovations.collaboratorDescription || ""}
                      onChange={(value) => setInnovations({ ...innovations, collaboratorDescription: value })}
                    />
                  </>
                }

                <div className="section"></div>

                <div className="title">
                  <h2>Partenaires</h2>
                </div>

                <label htmlFor="innovations-partnerTitle">Titre de la section partenaires</label>
                <input
                  id="innovations-partnerTitle"
                  name="partnerTitle"
                  onChange={(e) => setInnovations({...innovations, partnerTitle: e.target.value})}
                  defaultValue={innovations.partnerTitle || ""}
                />

                <label>Description de la section partenaires</label>
                <TextEditor
                  value={innovations.partnerDescription || ""}
                  onChange={(value) => setInnovations({...innovations, partnerDescription: value})}
                />

                <div className="list-container">
                  {!addPartner && partners && partners.map((partner, i) => (
                    <Partner
                      key={partner?._id || 'partner' + i}
                      partnerValue={partner}
                      companyId={param.companyId}
                      lang={lang}
                      context={context}
                      setRemoveAction={setRemoveAction}
                      openSelectPartnerVideo={openSelectPartnerVideo}
                      openSelectPicture={openSelectPicture}
                      dispatch={dispatch}
                      theme={theme}
                      index={i}
                    />
                  ))}
                </div>

                <div className="btn-container">
                  <button
                    className={`btn primary ${theme}-bg`}
                    style={{ marginBottom: 20 }}
                    onClick={() => setPartners([...(partners || []), {}])}
                    type="button"
                  >
                    Ajouter un partenaire
                  </button>
                </div>

              </div>

              <div className="col-2">
                <div className="btn-actions-container" >
                  {publishIsLoading ?
                    null
                    :
                    <button
                      className={`btn primary publish ${theme}-bg`}
                      type="submit"
                      >
                      Publier
                    </button>
                  }
                </div>

                <label>Photo de couverture <span className={`${theme}-color required`}>*</span><br/><span className="note">minimum 1700 x 350 px , 72 dpi</span></label>
                {renderCoverImg()}
                <div className="btn-container">

                  <button
                    type="button"
                    className={`btn primary ${theme}-bg`}
                    onClick={() => openSelectCover(true)}
                    >
                    Parcourir
                  </button>

                  {innovations.picture && !innovations.cover &&
                    <button
                      type="button"
                      className={`btn primary ${theme}-bg`}
                      onClick={() => setRemoveAction({ function:() => setInnovations({...innovations, picture: null })})}
                      >
                      Supprimer
                    </button>
                  }
                  {innovations.cover &&
                    <button
                      type="button"
                      className={`btn primary ${theme}-bg`}
                      onClick={() => setRemoveAction({ function:() => setInnovations({...innovations, cover: null })})}
                      >
                      Supprimer
                    </button>
                  }
                </div>

              </div>
            </div>

            <MetaSeo
              seo={innovations?.seo}
              onChange={(seoData) => {
                setInnovations({...innovations, seo: seoData});
                setIsSaved(false);
              }}
              theme={theme}
              companyId={param.companyId}
            />

        </form>
        <SelectMedia
          displaySelectMedia={displaySelectMedia}
          dispatch={dispatch}
          theme={theme}
          context={context}
          mediaType={mediaType}
          selectedMediaList={selectedMediaList}
          companyId={param.companyId}
          isMulti={mediaIsMulti}
          handleChange={(value) => submitMedia(value)}
          setDisplaySelectMedia={setDisplaySelectMedia}
        />
      </div>
    )
  }

  return (
    <>
      <PromptRouter when={!isSaved} />
      {isMounted && innovations && <div id="innovation" className={`page-container site ${theme}`}>
        <div className="page-content">

          <div className="title-row space-between">

            <div className="flex">

              <div className="title">
                <h1>Edition des innovations ({lang})</h1>
                <div className="bar primary"></div>
              </div>

            </div>

          </div>

          <div className="list-container">
            {renderEdit()}
          </div>

        </div>
      </div>}
      <RemoveModale removeAction={removeAction} setRemoveAction={setRemoveAction} theme={theme}/>
    </>

  )
}
